import { supabase } from '@/lib/supabase';
import { optimizeImage } from '@/lib/imagePipeline';

/**
 * Community banner uploads — optimized WebP into the public `community-banners`
 * bucket under the uploader's folder (RLS-scoped), returning the hosted URL.
 * Data URLs in `communities.banner` are banned; this is the only sanctioned
 * write path.
 */
export async function uploadCommunityBanner(file: File | Blob, userId: string): Promise<string> {
  const optimized = await optimizeImage(file, 'banner');
  const path = `${userId}/${crypto.randomUUID()}.${optimized.ext}`;
  const { error } = await supabase.storage
    .from('community-banners')
    .upload(path, optimized.blob, { contentType: 'image/webp', cacheControl: '31536000' });
  if (error) throw error;
  return supabase.storage.from('community-banners').getPublicUrl(path).data.publicUrl;
}
